<template>
  <div id="alertDiscontinuedContainer">
    <div class="alertDiscontinuedContent">
      <v-row align="center" justify="center">
        <v-col cols="1">
          <v-icon size="32" color="blue">fas fa-exclamation-circle</v-icon>
        </v-col>
        <v-col class="alert-discontinued-text">
          Alerts will be removed during late 2023 as we enhance your ability to
          set notifications for all Seerist content. We will replace Alerts with
          a Notifications Management module, with notifications for Events and
          Analysis driven from Search. This will increase efficiency, allowing
          you to easily modify your settings based on search results. To get
          ahead of this transition, please start using Search to set up and
          manage notifications for Events and Analysis.
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
export default {
  name: "AlertDiscontinuedInfo",
};
</script>

<style scoped lang="scss">
#alertDiscontinuedContainer {
  margin: 5px 5px 5px 5px;
}
.alertDiscontinuedContent {
  border-radius: 25px;
  border: 2px solid $primary-color;
  padding: 0px 10px 0px 10px;
  width: 100%;
  height: 150px;
  display: flex !important;
}
.alert-discontinued-text {
  font-size: 12px;
  padding-top: 0px;
  padding-bottom: 0px;
}
</style>
